import { IRouteItemNavLink } from 'interfaces/route.interfaces';
import { RouteItemId } from 'common/enums/html.enums';
import { Routes } from 'constants/route.constants';
import { ReactComponent as AddressCardIcon } from 'img/icons/address-card.svg';
import { ReactComponent as UsersIcon } from 'img/icons/users.svg';
import { ReactComponent as DictionaryIcon } from 'img/icons/sidebar/book.svg';
import { ReactComponent as HomeIcon } from 'img/icons/home.svg';
import { PoliciesPermissionSetItems as Permission } from 'common/constants/permissions';
import commonMessages from 'common/messages/messages';

export const homeNavLink: IRouteItemNavLink = {
  type: 'navLink',
  id: RouteItemId.RouteItemBtnHome,
  path: Routes.HOME,
  title: commonMessages.homeTitle,
  icon: HomeIcon,
  iconViewBox: '0 0 24 24',
};

export const membersNavLink: IRouteItemNavLink = {
  type: 'navLink',
  id: RouteItemId.RouteItemBtnMembers,
  path: Routes.MEMBERS,
  title: commonMessages.members,
  icon: AddressCardIcon,
  iconViewBox: '0 0 20 20',
  permissions: [Permission.MEMBER_VIEW],
};

export const employeesNavLink: IRouteItemNavLink = {
  type: 'navLink',
  id: RouteItemId.RouteItemBtnEmployees,
  path: Routes.EMPLOYEES,
  title: commonMessages.employees,
  icon: UsersIcon,
  iconViewBox: '0 0 20 20',
  permissions: [Permission.EMPLOYEE_VIEW],
};

export const dictionaryNavLink: IRouteItemNavLink = {
  type: 'navLink',
  id: RouteItemId.RouteItemBtnDictionariesContainer,
  path: Routes.DICTIONARIES,
  title: commonMessages.dictionaries,
  icon: DictionaryIcon,
  iconViewBox: '0 0 20 20',
  permissions: [
    Permission.CAME_FROM_INDICATION_VIEW,
    Permission.ADDITIONAL_GUEST_FIELD_VIEW,
    Permission.ALERT_SOUND_VIEW,
    Permission.NOTE_CODE_VIEW,
    Permission.FALLTHROUGH_REASON_VIEW,
    Permission.DEPARTMENT_VIEW,
    Permission.CLIENT_GROUP_VIEW,
    Permission.INSURANCE_COMPANY_VIEW,
    Permission.ACCESS_HOUR_VIEW,
    Permission.EVENT_TAG_VIEW,
    Permission.RESOURCE_TAG_VIEW,
    Permission.NOTIFICATION_VIEW,
    Permission.HELP_INFORMATION_VIEW,
    Permission.END_REASON_VIEW,
  ],
};
